var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout_container"},[_c('top-section',{attrs:{"is-show-cube":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }